import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import { ROLES } from "../auth/role"
import RoleContext from "../auth/RoleContext"
import { useContext, useEffect, useState } from "react"

export default function UserRolesSelection(props = { label: undefined, noSelectionLabel: 'Select A Role', onSelect: undefined, value: undefined}) {
  const roleDetails = useContext(RoleContext)

  const roleAccessMappings = [
    { choice: ROLES.ADMIN, restrictTo: [ROLES.ADMIN]},
    { choice: ROLES.MFI_ADMIN, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN]},
    { choice: ROLES.QSE_MGR, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN]},
    { choice: ROLES.SUPPLY_CHAIN_MGR, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.SUPPLY_CHAIN_MGR]},
    { choice: ROLES.QSE_SAFETY_MANAGER, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN]},
    { choice: ROLES.QSE_SUSTAINABILITY_MGR, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN]},
    { choice: ROLES.QSE_MEMBER, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.QSE_MGR, ROLES.QSE_SAFETY_MANAGER]},
    { choice: ROLES.IM_MANAGER, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.IM_MANAGER]},
    { choice: ROLES.IM_VIEWER, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.IM_MANAGER]},
    { choice: ROLES.BOTTLER, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.QSE_MGR, ROLES.QSE_SAFETY_MANAGER, ROLES.QSE_SUSTAINABILITY_MGR]},
    { choice: ROLES.BOTTLER_CORP, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.QSE_MGR, ROLES.QSE_SAFETY_MANAGER, ROLES.QSE_SUSTAINABILITY_MGR]},
    { choice: ROLES.BOTTLER_SUPPLY_CHAIN, restrictTo: [ROLES.ADMIN, ROLES.MFI_ADMIN, ROLES.SUPPLY_CHAIN_MGR]}
  ]

  const getMyChoices = () => {
    const _c = roleAccessMappings.reduce((p, c,i) => {
      if (roleDetails.hasRole(c.restrictTo)) {
        return [...p, c]
      }
      return p
    }, [])

    return _c
  }

return (
  <FormControl fullWidth >
    { props.label && <InputLabel>{props.label}</InputLabel>}
    <Select size='small' fullWidth id={`role_select`} value={props.value ?? undefined} defaultValue={ props.value === undefined ? 0 : undefined} 
      onChange={(event) => { 
        if (props.onSelect !== undefined) props.onSelect(event)
      }} 
    >
      <MenuItem value={0}>{props.noSelectionLabel}</MenuItem>
      { getMyChoices().map((c, i) => <MenuItem value={c.choice.id} key={i}>{c.choice.name}</MenuItem>)}
    </Select>
  </FormControl>
)

}